import {ITEM_SIZE_SIDE_NAVBAR} from 'styles/StyleConstants';

export interface PanelOffset {
  mainAxis: number;
  crossAxis: number;
}

/**
 * Popover offsets that dock the notification panel to the bottom-left of the page, `gap` from the
 * nav rail (which spans the left edge at ITEM_SIZE_SIDE_NAVBAR wide) and from the page bottom. The
 * panel stays anchored to the bell (positioned `right-end`) so its caret points at it; the offsets
 * bridge from the bell's right and bottom edges to that docked position.
 */
export function getPanelOffset(
  bellRect: Pick<DOMRect, 'right' | 'bottom'>,
  viewportHeight: number,
  gap: number
): PanelOffset {
  return {
    mainAxis: ITEM_SIZE_SIDE_NAVBAR + gap - bellRect.right,
    crossAxis: viewportHeight - gap - bellRect.bottom,
  };
}
